import PathWrapper from "core/PathWrapper";

export const jpBasePath = new PathWrapper('jp');